module.exports = __webpack_public_path__ + "static/media/PRACTICA6.efcdad3f.jpg";